/* =========================================================================
   Chorus Beer Shopify theme — theme.js (foundation slice)
   Vanilla JS, no framework. Adds:
     - Announcement marquee rotation
     - Header scroll-darken (when transparent_on_home is on)
     - Reveal-on-scroll for .reveal elements
   Cart drawer, age gate, sticky add-to-bag, search modal: iter 2.
   ========================================================================= */
(function () {
  'use strict';

  // ---- Announcement marquee rotation ----
  function initAnnouncement(el) {
    var messages = el.querySelectorAll('.chorus-announce__message');
    if (messages.length < 2) return;
    var rotation = parseInt(el.getAttribute('data-rotation'), 10) || 4200;
    var i = 0;
    setInterval(function () {
      messages[i].style.display = 'none';
      messages[i].classList.remove('is-active');
      i = (i + 1) % messages.length;
      messages[i].style.display = 'inline-block';
      messages[i].classList.add('is-active');
    }, rotation);
  }

  // ---- Header background when transparent + scrolled ----
  function initHeaderScroll() {
    var header = document.querySelector('.site-header');
    if (!header || header.getAttribute('data-transparent') !== 'true') return;
    var black = 'var(--chorus-black)';
    function update() {
      if (window.scrollY > 80) {
        header.style.background = black;
        header.style.borderBottom = '1px solid rgba(244,239,230,0.08)';
      } else {
        header.style.background = 'transparent';
        header.style.borderBottom = '1px solid transparent';
      }
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  // ---- Reveal-on-scroll ----
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window) || els.length === 0) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  // ---- Boot ----
  function boot() {
    document.querySelectorAll('.chorus-announce').forEach(initAnnouncement);
    initHeaderScroll();
    initReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
